import { render, staticRenderFns } from "./NewMenuManagementV2.vue?vue&type=template&id=e347516e&scoped=true"
import script from "./NewMenuManagementV2.vue?vue&type=script&lang=js"
export * from "./NewMenuManagementV2.vue?vue&type=script&lang=js"
import style0 from "./NewMenuManagementV2.vue?vue&type=style&index=0&id=e347516e&prod&lang=scss&scoped=true"
import style1 from "./NewMenuManagementV2.vue?vue&type=style&index=1&id=e347516e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e347516e",
  null
  
)

export default component.exports